import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { PhoneNumberType } from 'google-libphonenumber'
import { isNil } from 'ramda'
import * as Yup from 'yup'

import { globalDefinitions } from '@/defined-translations'
import '@/yup-phone-number/lib'

const generateAddContactFormSchema = () => {
  return Yup.object().shape(
    {
      id: Yup.string().optional(),
      healthblocksId: Yup.string(),
      order: Yup.number(),
      givenName: Yup.string()
        .max(100, i18n._(globalDefinitions.maxLength, { value: 100 }))
        .required(i18n._(globalDefinitions.required)),
      familyName: Yup.string()
        .max(100, i18n._(globalDefinitions.maxLength, { value: 100 }))
        .required(i18n._(globalDefinitions.required)),
      kinshipId: Yup.string().required(i18n._(globalDefinitions.required)),
      primaryPhoneNumber: Yup.string().when(['email', 'additionalPhoneNumber'], {
        is: (email: string, additionalPhoneNumber: string) => isNil(email) && isNil(additionalPhoneNumber),
        then: Yup.string()
          .required(
            t({
              id: 'contactinfo.email-cellphone-contactPhone',
              message: 'Email of telefoon (vast) of telefoon (mobiel) is verplicht',
            }),
          )
          .phoneNumber([PhoneNumberType.FIXED_LINE], [], {
            type: i18n._(globalDefinitions.invalidTypeFixed),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneFixed),
          }),
        otherwise: Yup.string().when(['primaryPhoneNumber'], {
          is: (primaryPhoneNumber: string) => {
            return !isNil(primaryPhoneNumber)
          },
          then: Yup.string().phoneNumber([PhoneNumberType.FIXED_LINE], [], {
            type: i18n._(globalDefinitions.invalidTypeFixed),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneFixed),
          }),
          otherwise: Yup.string().notRequired(),
        }),
      }),
      additionalPhoneNumber: Yup.string().when(['email', 'primaryPhoneNumber'], {
        is: (email: string, primaryPhoneNumber: string) => isNil(email) && isNil(primaryPhoneNumber),
        then: Yup.string()
          .required(
            t({
              id: 'contactinfo.email-cellphone-contactPhone',
              message: 'Email of telefoon (vast) of telefoon (mobiel) is verplicht',
            }),
          )
          .phoneNumber([PhoneNumberType.MOBILE], [], {
            type: i18n._(globalDefinitions.invalidTypeMobile),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneMobile),
          }),
        otherwise: Yup.string().when(['additionalPhoneNumber'], {
          is: (additionalPhoneNumber: string) => {
            return !isNil(additionalPhoneNumber)
          },
          then: Yup.string().phoneNumber([PhoneNumberType.MOBILE], [], {
            type: i18n._(globalDefinitions.invalidTypeMobile),
            region: i18n._(globalDefinitions.invalidRegion),
            format: i18n._(globalDefinitions.invalidPhoneMobile),
          }),
          otherwise: Yup.string().notRequired(),
        }),
      }),
      address: Yup.object({
        streetAddress: Yup.string()
          .max(80, i18n._(globalDefinitions.maxLength, { value: 80 }))
          .matches(
            /.*\b\d+/,
            t({
              id: 'contactinfo.address-streetAddress',
              message: 'Gelieve ook een huisnummer in te voeren',
            }),
          )
          .required(
            t({
              id: 'globals.validation.required',
              message: 'Dit veld is verplicht',
            }),
          ),
        zipOrPostalCode: Yup.string()
          .max(7, i18n._(globalDefinitions.maxLength, { value: 7 }))
          .required(),
        city: Yup.string()
          .max(40, i18n._(globalDefinitions.maxLength, { value: 40 }))
          .required(),
        country: Yup.string().required(),
      }),
      email: Yup.string().when(['primaryPhoneNumber', 'additionalPhoneNumber'], {
        is: (primaryPhoneNumber: string, additionalPhoneNumber: string) =>
          isNil(primaryPhoneNumber) && isNil(additionalPhoneNumber),
        then: Yup.string()
          .required(
            t({
              id: 'contactinfo.email-cellphone-contactPhone',
              message: 'Email of telefoon (vast) of telefoon (mobiel) is verplicht',
            }),
          )
          .email(i18n._(globalDefinitions.invalidEmail)),
        otherwise: Yup.string().notRequired(),
      }),
    },
    [
      ['email', 'primaryPhoneNumber'],
      ['email', 'additionalPhoneNumber'],
      ['primaryPhoneNumber', 'additionalPhoneNumber'],
      ['primaryPhoneNumber', 'primaryPhoneNumber'],
      ['additionalPhoneNumber', 'additionalPhoneNumber'],
    ],
  )
}

export { generateAddContactFormSchema }
